import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'

// Elements
import Image from 'components/shared/Image'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import GravityForm from 'components/shared/GravityForm'
import TitleDefault from 'components/elements/TitleDefault'
import Content from 'components/shared/Content'
import HeroSecond from 'components/elements/HeroSecond'

const Container = styled.div`
  margin-top: -10rem;
`

const Info = styled(Content)`
  & p {
    font-size: ${(props) => props.theme.font.size.xm};

    & strong {
      font-family: ${(props) => props.theme.font.family.secondaryBold};
    }
  }
`

const Description = styled(Content)`
  & h2 {
    font-size: ${(props) => props.theme.font.size['80']};
    text-transform: uppercase;
    margin-bottom: 3rem;

    @media (max-width: 767px) {
      font-size: ${(props) => props.theme.font.size['60']};
    }
  }
`

const Title = styled(Content)`
  & h2 {
    font-size: ${(props) => props.theme.font.size['48']};
    text-transform: uppercase;
    @media (max-width: 767px) {
      font-size: ${(props) => props.theme.font.size['35']};
    }
  }
`

const PageTemplate = ({
  data: {
    page: { title, path, yoast_meta: yoast, acf },
  },
}) => {
  return (
    <Layout>
      <SEO yoast={yoast} path={path} article />

      <HeroSecond fields={{ image: acf.banner_contact }} />

      <section className="position-relative">
        <Container className="container color-background-light">
          <div className="row p-3 p-sm-5">
            <div className="col-12 mb-5 mt-5 mt-sm-0">
              <TitleDefault>{title}</TitleDefault>
            </div>

            <div className="col-lg-2" />
            <div className="col-lg-10 d-flex flex-wrap">
              <div className="col-lg-6 p-0">
                <Info content={acf.info.address} />
              </div>
              <div className="col-lg-6 p-0">
                <Info content={acf.info.zipaddress} />
              </div>

              <div className="col-lg-6 p-0">
                <Info content={acf.info.phone} />
              </div>

              <div className="col-lg-6 p-0">
                <Info content={acf.info.email} />
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section>
        <div className="container">
          <div className="row py-5 align-items-center">
            <div className="col-lg-5">
              <Image src={acf.koster.image} />
            </div>
            <div className="col-lg-7 mt-lg-0 mt-4">
              <Description content={acf.koster.description} />
            </div>
          </div>
        </div>
      </section>

      <section className="color-background-main my-3 my-lg-5">
        <div className="container">
          <div className="row py-5">
            <div className="col-lg-8 mx-auto">
              <div className="col-12 text-center">
                <Title content={acf.question.title} className="mb-5" />
              </div>
              <GravityForm id={1} />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      title
      path

      acf {
        banner_contact {
          localFile {
            childImageSharp {
              fluid(maxWidth: 1920, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }

        info {
          address
          zipaddress
          email
          phone
        }

        koster {
          image {
            localFile {
              publicURL
            }
          }
          description
        }

        question {
          title
        }
      }

      yoast_meta {
        name
        content
        property
      }
    }
  }
`

export default PageTemplate
